export default __webpack_public_path__ + "static/media/sweets-3.e6e520cf.jpeg";